import React from 'react'
import { useI18n } from '../i18n/i18n'

const LanguageSwitcher: React.FC = () => {
  const { lang, setLang } = useI18n()
  return (
    <div className="flex items-center gap-2" title="Language">
      <button
        onClick={() => setLang('en')}
        className={`px-2 py-1 rounded flex items-center gap-1 text-sm ${lang === 'en' ? 'bg-gray-200 text-gray-900' : 'text-gray-600 hover:bg-gray-100'}`}
        aria-label="Switch to English"
      >
        <span role="img" aria-label="English" className="text-base">🇬🇧</span>
        <span>EN</span>
      </button>
      <button
        onClick={() => setLang('es')}
        className={`px-2 py-1 rounded flex items-center gap-1 text-sm ${lang === 'es' ? 'bg-gray-200 text-gray-900' : 'text-gray-600 hover:bg-gray-100'}`}
        aria-label="Cambiar a Español"
      >
        <span role="img" aria-label="Español" className="text-base">🇪🇸</span>
        <span>ES</span>
      </button>
    </div>
  )
}

export default LanguageSwitcher

